import React, { PureComponent, Suspense } from "react";
import { WIDGETS } from "../constants/widgets";
import { connect } from "react-redux";
import { setGoogleAmpIframeHeight, setIframeHeight } from "../lib/iframe";
import { offerData } from "../lib/offerData";
import {
  invalidateSponsoredPositions,
  loadSponsoredPositions
} from "../actions/portalData/sponsoredPositionData";
import { OFFER_TYPES } from "../constants/offerTypes";

function offerResult(id, offerType) {
  switch (id) {
    case WIDGETS.inDepth_default_combi.id:
      if (offerType === OFFER_TYPES.phoneOffer) {
        return null;
      } else {
        return InDepthDefaultSharedOfferResult;
      }
    case WIDGETS.inDepth_default_proposition.id:
      return InDepthDefaultSharedOfferResult;
    case WIDGETS.inDepth_default_simOnly.id:
      return InDepthDefaultSharedOfferResult;
    case WIDGETS.topList_default_proposition.id:
      return TopListDefaultSharedOfferResult;
    case WIDGETS.topList_default_simOnly.id:
      return TopListDefaultSharedOfferResult;
    case WIDGETS.topList_inArticle_proposition.id:
      return TopListInArticleSharedOfferResult;
    case WIDGETS.topList_inArticle_simOnly.id:
      return TopListInArticleSharedOfferResult;
    default:
      return null;
  }
}

const InDepthDefaultSharedOfferResult = React.lazy(() =>
  import("../components/widgets/inDepth/default/shared/OfferResult")
);
const TopListDefaultSharedOfferResult = React.lazy(() =>
  import("../components/widgets/topList/default/shared/OfferResult")
);
const TopListInArticleSharedOfferResult = React.lazy(() =>
  import("../components/widgets/topList/default/shared/OfferResult")
);

class SponsoredPositionContainer extends PureComponent {
  componentDidMount() {
    const {
      clientConfig,
      invalidateSponsoredPositions,
      loadSponsoredPositions
    } = this.props;

    invalidateSponsoredPositions();

    if (clientConfig.options.showSponsoredPositions) {
      loadSponsoredPositions();
    }
  }

  componentDidUpdate(prevProps) {
    const { clientConfig, filter, invalidateSponsoredPositions, loadSponsoredPositions, offerType, portal } = this.props;

    if (
      (filter !== prevProps.filter ||
        offerType !== prevProps.offerType ||
        portal.id !== prevProps.portal.id) &&
      clientConfig.options.showSponsoredPositions
    ) {
      invalidateSponsoredPositions();
    }
    
    if (
      clientConfig.options.showSponsoredPositions &&
      this.sponsoredPositionDataInvalid() &&
      (this.sponsoredPositionDataFetchingTime() > 5 ||
        this.didInvalidateChanged(prevProps))
    ) {
      loadSponsoredPositions();
    }

    if (clientConfig.options.inGoogleAmp) {
      setGoogleAmpIframeHeight();
    } else if (clientConfig.options.inIframe) {
      setIframeHeight();
    }
  }

  render() {
    const {
      clientConfig,
      offerType,
      portal,
      updateExperiment,
      updateModal,
      widgetOptions
    } = this.props;

    try {
      if (clientConfig.options.showSponsoredPositions) {
        const SelectedOfferResult = offerResult(clientConfig.widget, offerType);
        const sponsoredPosition = this.getSponsoredPosition();
        const sponsoredPositionInvalid = this.sponsoredPositionDataInvalid();

        if (sponsoredPosition && !sponsoredPositionInvalid) {
          return (
            <Suspense fallback={<div> </div>}>
              <SelectedOfferResult
                clientConfig={clientConfig}
                offerType={offerType}
                portal={portal}
                portalOfferResult={{ ...sponsoredPosition }}
                updateExperiment={updateExperiment}
                updateModal={updateModal}
                widgetOptions={widgetOptions}
              />
            </Suspense>
          );
        } else {
          return null;
        }
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }

  didInvalidateChanged(prevProps) {
    const { sponsoredPositionsState } = this.props;

    return (
      sponsoredPositionsState.didInvalidate !==
      prevProps.sponsoredPositionsState.didInvalidate
    );
  }

  getSponsoredPosition() {
    const { clientConfig, offerType, portalData } = this.props;

    if (this.hasSponsoredPositionData()) {
      return offerData(
        clientConfig,
        offerType,
        "sponsoredPosition",
        portalData
      )[0];
    }
  }

  hasSponsoredPositionData() {
    const { portalData } = this.props;

    return portalData.entities.sponsoredPositions.length !== 0;
  }

  sponsoredPositionDataInvalid() {
    const { sponsoredPositionsState } = this.props;

    return sponsoredPositionsState.didInvalidate;
  }

  sponsoredPositionDataFetchingTime() {
    const { sponsoredPositionsState } = this.props;

    return (Date.now() - sponsoredPositionsState.startFetching) / 1000;
  }
}

function mapStateToProps(state) {
  return {
    filter: state.filter[state.offerType],
    offerType: state.offerType,
    sponsoredPositionsState: state.portalData.status.sponsoredPositions,
    portalData: state.portalData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    invalidateSponsoredPositions: () => {
      dispatch(invalidateSponsoredPositions());
    },
    loadSponsoredPositions: (
      clientConfig,
      status,
      filter,
      offerType,
      withDetails
    ) => {
      dispatch(
        loadSponsoredPositions(
          clientConfig,
          status,
          filter,
          offerType,
          withDetails
        )
      );
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const {
    invalidateSponsoredPositions,
    loadSponsoredPositions
  } = dispatchProps;
  const { portalData, filter } = stateProps;
  const { clientConfig, offerType } = ownProps;
  const withDetails = true;

  return {
    ...stateProps,
    ...ownProps,
    invalidateSponsoredPositions: () => invalidateSponsoredPositions(),
    loadSponsoredPositions: () =>
      loadSponsoredPositions(
        clientConfig,
        portalData.status.sponsoredPositions,
        { ...filter, limit: 1 },
        offerType,
        withDetails
      )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SponsoredPositionContainer);
